import { render, staticRenderFns } from "./WhatsappFloat.vue?vue&type=template&id=6ab1de6c&scoped=true"
import script from "./WhatsappFloat.vue?vue&type=script&lang=js"
export * from "./WhatsappFloat.vue?vue&type=script&lang=js"
import style0 from "./WhatsappFloat.vue?vue&type=style&index=0&id=6ab1de6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab1de6c",
  null
  
)

export default component.exports